/**
 * Loader slice — global loading flag used to show/hide a full-page spinner.
 * Prefer the SDUI per-action loading flags for component-level loading states;
 * use this only for coarse, app-wide blocking operations (e.g. initial auth).
 */
import { createSlice } from '@reduxjs/toolkit'

export type LoadingState = {
    loading: boolean
}

const initialState: LoadingState = {
    loading: false,
}

export const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
    },
})

export const { setLoading } = loaderSlice.actions

export default loaderSlice.reducer
